/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_DocumentsInputs */

const en_why_listening_compare_documents = /** @type {(inputs: Why_Listening_Compare_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs, documents and web pages`)
};

const es_why_listening_compare_documents = /** @type {(inputs: Why_Listening_Compare_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF, documentos y páginas web`)
};

/**
* | output |
* | --- |
* | "PDFs, documents and web pages" |
*
* @param {Why_Listening_Compare_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_documents = /** @type {((inputs?: Why_Listening_Compare_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_documents(inputs)
	return en_why_listening_compare_documents(inputs)
});